import type { Reducer } from 'react';
import { useReducer } from 'react';

import type { NavigationAction } from './actions';
import { goBack, gotoItem } from './actions';
import { getInitalState, reducer } from './reducer';
import type { NavigationState } from 'client-site-chrome-ui/components/molecules/NavigationDrilldown/types';
import type { DrilldownNavItem } from 'client-site-chrome-ui/types/drilldownNavItem';

export const useNavigation = (navigation: DrilldownNavItem) => {
  const [state, dispatch] = useReducer<Reducer<NavigationState, NavigationAction>>(
    reducer,
    getInitalState(navigation),
  );

  return {
    state,
    onBack: () => {
      dispatch(goBack());
    },
    onSelect: (item: DrilldownNavItem) => {
      dispatch(gotoItem(item));
    },
  };
};
